import { useEffect, useState } from 'react';
import {
  getPriceForPlan,
  billingCycleFromDuration,
  computeExpiryDate,
} from '../../../services/owner/subscriptionsApi';

const emptyForm = {
  gym: '',
  planId: '',
  billingCycle: 'Monthly',
  price: '',
  startDate: new Date().toISOString().slice(0, 10),
  expiryDate: '',
  status: 'active',
  contactEmail: '',
};

function GymSubscriptionForm({ initialData, onSubmit, onCancel, submitLabel, plans = [] }) {
  const activePlans = plans.filter((p) => p.status === 'active');
  const defaultPlanId = initialData?.planId || activePlans[0]?.id || '';

  const [form, setForm] = useState(() => ({
    ...emptyForm,
    planId: defaultPlanId,
    ...initialData,
    price: initialData?.price != null ? String(initialData.price) : emptyForm.price,
  }));

  useEffect(() => {
    if (initialData || !form.planId) return;
    setForm((prev) => ({
      ...prev,
      price: String(getPriceForPlan(prev.planId, prev.billingCycle, plans)),
      expiryDate: computeExpiryDate(prev.startDate, prev.billingCycle),
    }));
  }, [form.planId, form.billingCycle, form.startDate, initialData, plans]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const plan = plans.find((p) => p.id === form.planId);
    onSubmit?.({
      ...form,
      planName: plan?.name,
      billingCycle: billingCycleFromDuration(form.billingCycle.toLowerCase()),
      price: Number(form.price),
    });
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit}>
      <div className="owner-grid-2">
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-gym">Gym Name</label>
          <input
            id="sub-gym"
            name="gym"
            className="owner-form-input"
            value={form.gym}
            onChange={handleChange}
            placeholder="e.g. FitZone Downtown"
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-email">Contact Email</label>
          <input
            id="sub-email"
            name="contactEmail"
            type="email"
            className="owner-form-input"
            value={form.contactEmail}
            onChange={handleChange}
            placeholder="admin@gym.com"
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-plan">Plan</label>
          <select
            id="sub-plan"
            name="planId"
            className="owner-form-select"
            value={form.planId}
            onChange={handleChange}
            required
          >
            {activePlans.length === 0 ? (
              <option value="">No plans available</option>
            ) : (
              activePlans.map((plan) => (
                <option key={plan.id} value={plan.id}>{plan.name}</option>
              ))
            )}
          </select>
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-billing">Billing Cycle</label>
          <select
            id="sub-billing"
            name="billingCycle"
            className="owner-form-select"
            value={form.billingCycle}
            onChange={handleChange}
            required
          >
            <option value="Monthly">Monthly</option>
            <option value="Quarterly">Quarterly</option>
            <option value="Yearly">Yearly</option>
          </select>
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-price">Price</label>
          <input
            id="sub-price"
            name="price"
            type="number"
            min="0"
            className="owner-form-input"
            value={form.price}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-status">Status</label>
          <select
            id="sub-status"
            name="status"
            className="owner-form-select"
            value={form.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="expired">Expired</option>
          </select>
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-start">Start Date</label>
          <input
            id="sub-start"
            name="startDate"
            type="date"
            className="owner-form-input"
            value={form.startDate}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="sub-expiry">Expiry Date</label>
          <input
            id="sub-expiry"
            name="expiryDate"
            type="date"
            className="owner-form-input"
            value={form.expiryDate}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="subscription-form-actions">
        <button type="submit" className="owner-btn owner-btn-primary">{submitLabel}</button>
        {onCancel && (
          <button type="button" className="owner-btn owner-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default GymSubscriptionForm;
